import { Head, usePage } from "@inertiajs/react";
import type { ReactNode } from "react";
import { configure } from "@/_generated/routes/routes";
import { Toaster } from "@/components/ui/sonner";
import { useFlash } from "@/hooks/use-flash";
import type { BizminerInertiaSharedProps } from "@/types/inertia";

interface PersistentLayoutProps {
  children: ReactNode;
}

export default function PersistentLayout({ children }: PersistentLayoutProps) {
  const pageProps = usePage<BizminerInertiaSharedProps>().props;
  const { page_title, default_url_options } = pageProps;

  // Synchronously update js-routes config before children render.
  // This ensures route helpers have the correct default_url_options
  // even during popstate (browser back) restoration.
  if (default_url_options) {
    configure({ default_url_options });
  }

  useFlash();

  return (
    <>
      <Head title={page_title} />
      {children}
      <Toaster position="top-center" richColors />
    </>
  );
}
